export default __webpack_public_path__ + "static/media/sports6.2507f6d8.jpg";